import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './components/home/home'
import Game from './components/game/game'
import NotFound from './components/notFound/notFound'
import NewGame from './components/newGame/newGame'
import ContinueGame from './components/continueGame/continueGame'
import Upload from './components/upload/upload'
import Settings from './components/home/settings'
import Feedback from './components/home/feedback'
import MorgoEgg from './components/morgoEgg'
import Admin from './components/admin/admin'
import { UserNamesProvider } from './contexts/userNames'

export class App extends React.PureComponent {
    render() {
        return (
            <UserNamesProvider>
                <Router>
                    <Switch>
                        <Route exact path='/' component={Home} />
                        <Route path='/game/new' component={NewGame} />
                        <Route path='/game/continue' component={ContinueGame} />
                        <Route path='/game/🦚' component={MorgoEgg} />
                        <Route path='/game/morgobaby' component={MorgoEgg} />
                        <Route path='/game/:gameId' component={Game} />
                        <Route path='/upload' component={Upload} />
                        <Route path='/settings' component={Settings} />
                        <Route path='/feedback' component={Feedback} />
                        <Route path='/admin' component={Admin} />
                        <Route component={NotFound} />
                    </Switch>
                </Router>
            </UserNamesProvider>
        )
    }
}

export default App
